export const SAP_SYSTEM_ROLES = ['GREENFIELD', 'LEGACY_REFERENCE'] as const;
export type SapSystemRole = (typeof SAP_SYSTEM_ROLES)[number];

export const SAP_MODULE_SCOPES = ['S4_CORE', 'EWM'] as const;
export type SapModuleScope = (typeof SAP_MODULE_SCOPES)[number];

export type SapSystemEntry = string | { name: string; role?: SapSystemRole; moduleScope?: SapModuleScope };

export type SapConnectionView = {
    id: string;
    clientId: string;
    mcpUrl: string;
    maskedApiKey: string;
    systems: SapSystemEntry[];
    defaultSystem: string | null;
    enabled: boolean;
    createdAt: string;
    updatedAt: string;
};

export type UpsertSapConnectionParams = {
    mcpUrl: string;
    apiKey?: string;
    systems: SapSystemEntry[];
    defaultSystem?: string | null;
    enabled: boolean;
};

export type TestSapConnectionParams = {
    mcpUrl: string;
    apiKey?: string;
    systems: string[];
    defaultSystem?: string | null;
};

export type TestSapConnectionResult =
    | {
          ok: true;
          systems: string[];
      }
    | {
          ok: false;
          error: 'mcp_unreachable' | 'mcp_auth_failed';
      };
